import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import Logo from './Logo';
import { PHONE, PHONE_HREF } from '../contact.config';
import '../styles/navbar.css';

const links = [
  { label:'Home',      to:'/' },
  { label:'Products',  to:'/products' },
  { label:'Services',  to:'/services' },
  { label:'Blog',      to:'/blog' },
  { label:'Portfolio', to:'/portfolio' },
  { label:'Contact',   to:'/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);
  useEffect(() => { setMenuOpen(false); }, [pathname]);

  return (
    <>

      <nav className={`navbar${scrolled?' scrolled':''}`} aria-label="Main Navigation">
        <Link to="/" className="nav-logo-link">
          <Logo size="md" showText={true}/>
        </Link>
        <ul className="nav-links-desktop">
          {links.map(l=>(
            <li key={l.to}><Link to={l.to} className={pathname===l.to||(l.to!=='/' && pathname.startsWith(l.to))?'active':''}>{l.label}</Link></li>
          ))}
        </ul>
        <div className="nav-right">
          <span className="nav-free-pill">Free Consultation Available</span>
          <Link to="/book-online" className="nav-book-btn">Book Now</Link>
          <button className="nav-hamburger" onClick={()=>setMenuOpen(o=>!o)} aria-label="Menu">
            {menuOpen?<X size={20}/>:<Menu size={20}/>}
          </button>
        </div>
      </nav>

      {/* Mobile overlay */}
      <div className={`mobile-overlay${menuOpen?' open':''}`}>
        <div className="mobile-logo-section">
          <Logo size="lg" showText={false}/>
          <div>
            <div className="mobile-brand-name">YN Dream Curtains</div>
            <div className="mobile-brand-sub">Excellence and Elegance</div>
            <a href="https://yndreamcurtains.com" target="_blank" rel="noopener noreferrer" className="mobile-contact-link">
              yndreamcurtains.com
            </a>
            <a href={PHONE_HREF} className="mobile-contact-link">{PHONE}</a>
          </div>
        </div>
        {links.map(l=>(
          <Link key={l.to} to={l.to}
            className={`mobile-nav-link${pathname===l.to||(l.to!=='/' && pathname.startsWith(l.to))?' active':''}`}>
            {l.label}
          </Link>
        ))}
        <Link to="/book-online" className="mobile-book-btn">Book Free Consultation →</Link>
        <div className="mobile-legal-row">
          <Link to="/privacy-policy" className="mobile-legal-a">Privacy Policy</Link>
          <Link to="/terms"          className="mobile-legal-a">Terms & Conditions</Link>
          <Link to="/refund-policy"  className="mobile-legal-a">Refund Policy</Link>
          <Link to="/accessibility"  className="mobile-legal-a">Accessibility</Link>
        </div>
      </div>
    </>
  );
}
